import { lazy } from 'react';
const FacturasFull = lazy(() => import('../../pages/facturasFull'));
const PagosFull = lazy(() => import('../../pages/pagosFull'));
const ConsultoriosFull = lazy(async () => await import('../../pages/consultoriosFull'));

const fullPagesRoutes = [
  {
    title: 'Consulta de Pagos y Facturas',
    path: 'facturasFull',
    component: FacturasFull,
    permission: 'consulta-de-facturas/pagos',
    isPrivate: true,
  },
  {
    title: 'Consulta de Pagos y Facturas',
    path: 'pagosFull',
    component: PagosFull,
    permission: 'consulta-de-facturas/pagos',
    isPrivate: true,
  },
  {
    title: 'Consulta de Pagos y Facturas',
    path: 'consultoriosFull',
    component: ConsultoriosFull,
    permission: 'consulta-de-facturas/pagos',
    isPrivate: true,
  },
];

export default fullPagesRoutes;
